import { EntityStatus } from './EntityStatus.model';

export class ExternalDocumentDto {
  public externalDocumentID: string;
  public regulatoryUpdateID: string;
  public prioritySubmissionID: string;
  public annualCountForecastItemID: string;
  public annualPlanItemID: string;
  public permitID: string;
  public documentLocation: string;
  public documentFileName: string;
  public documentDescription: string;
  public comments: string;
  file: any;
  public itemStatus: EntityStatus;
}
